module.exports = __webpack_public_path__ + "static/media/Curation_Icon.e97f4b0c.png";